<template>
  <div class="container-fluid contact">
    <div class="container">
      <form>
        <div class="row">
          <div class="col-12">
            <h3 id="contact">Kontaktujte ma</h3>
            <p>
              Ak vás niečo z mojej tvorby zaujalo alebo máte akékoľvek otázky ohľadom mojej tvorby, stačí ma kontaktovať cez
              <a
                href="https://www.facebook.com/HandmadeByDenisecko"
                target="_blank"
                rel="external"
              >Facebook stránku</a> alebo mi napíšte priamo na
              <a
                href="http://m.me/HandmadeByDenisecko?ref=denisecko.sk"
                target="_blank"
                rel="external"
              >Messenger</a>.
            </p>
          </div>
          <div class="col">
            <!-- <div class="form-group">
              <input type="text" class="form-control" placeholder="Vaše meno">
            </div>
            <div class="form-group">
              <input type="email" class="form-control" placeholder="Email">
            </div>
            <div class="form-group">
              <textarea name id rows="5" class="form-control" placeholder="Vaša správa"></textarea>
            </div>
            <div class="row">
              <div class="col text-center">
                <button type="submit" class="btn btn-primary">Odoslať</button>
              </div>
            </div>-->
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
